<template>
  <div>
    <h2>Geral</h2>
    <div class="row mb-4">
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="nome">Nome</label>
          <input type="text" readonly class="form-control-plaintext" id="nome" value="Renato Aragão">
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="usuario">Usuário</label>
          <input type="text" readonly class="form-control-plaintext" id="usuario" value="renatoaragao">
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-inline">
          <div class="form-group">
            <label for="senha">Senha</label>
            <input type="text" readonly class="form-control-plaintext" id="senha" value="********">
          </div>
          <button type="submit" class="btn btn-primary btn-sm mb-2">Alterar senha</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mb-4">
        <h2>Função e Telefone</h2>
        <div class="form-group">
          <label for="funcao">Função</label>
          <select class="form-control" id="funcao">
            <option value="">1</option>
            <option value="">2</option>
            <option value="">3  </option>
          </select>
        </div>
        <div class="form-group">
          <label for="telefone">Telefone</label>
          <input type="text" class="form-control" id="telefone" placeholder="(00) 00000-0000" />
        </div>
      </div>
      <div class="col-12 col-md-8 mb-4">
        <h2>Endereço</h2>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="endereco">Endereço</label>
              <input type="text" class="form-control" id="endereco" placeholder="Rua, Av, Travessa" />
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label for="numero">Número</label>
              <input type="text" class="form-control" id="numero" />
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label for="cep">CEP</label>
              <input type="text" class="form-control" id="cep" placeholder="00000-000" />
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="form-group">
              <label for="uf">UF</label>
              <select class="form-control" id="uf">
                <option value="">1</option>
                <option value="">2</option>
                <option value="">3</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="cidade">Cidade</label>
              <input type="text" class="form-control" id="cidade" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContaPerfil'
}
</script>

<style scoped>

</style>
